<template>
  <div ref="wrapper" class="position-relative wrapper" :style="wrapperStyle">
    <div v-if="!hasIUrl" class="preview-skeleton">
      <skeleton-rectangle></skeleton-rectangle>
    </div>
    <div v-else-if="isError">
      <div class="centered-text">
        <cool-label>No sample image</cool-label>
      </div>
    </div>
    <!-- make frame invisible until it's sized, otherwise it'll flicker onto the screen full-sized and nobody wants to see that -->
    <iframe v-else class="frame" :class="{ 'invisible': state !== 'ready' }" ref="frame" :src="iurl" frameBorder="0" marginwidth="0" marginheight="0" @load="resizeToFit"></iframe>
  </div>
</template>

<script>
import SkeletonRectangle from '@/components/SkeletonRectangle'

export default {
  props: {
    height: { type: String, default: '100%' },
    width: { type: String, default: '100%' }
  },
  data () {
    return {
      stateVar: 'loading'
    }
  },
  methods: {
    resizeToFit () {
      this.$nextTick(() => {
        // frame.width = frame.contentWindow.document.body.scrollWidth
        // frame.height = frame.contentWindow.document.body.scrollHeight

        let wrapper = this.$refs.wrapper
        let wrapperWidth = wrapper.offsetWidth
        let wrapperHeight = wrapper.offsetHeight
        let frame = this.$refs.frame
        let frameWidth = frame.contentDocument.body.scrollWidth
        let frameHeight = frame.contentDocument.body.scrollHeight

        let widthPercent = wrapperWidth/frameWidth
        let heightPercent = wrapperHeight/frameHeight

        frame.contentDocument.body.style.overflow = 'hidden'

        if (widthPercent < heightPercent) {
          frame.style.transform = 'scale(' + widthPercent + ') translate(-50%, -50%)';
        } else {
          frame.style.transform = 'scale(' + heightPercent + ') translate(-50%, -50%)';
        }
        frame.style.transformOrigin = 'top left'
        frame.style.width = frameWidth + 'px'
        frame.style.height = frameHeight + 'px'
        this.state = 'ready'
        frame.style.visibility = 'visible'
      })
    },
  },
  computed: {
    hasIUrl () {
      return !(this.iurl === 'loading')
    },
    isError () {
      return !this.iurl || this.iurl.length === 0
    },
    wrapperStyle () {
      return 'height: ' + this.height + '; width: ' + this.width + ';'
    }
  },
  components: {
    SkeletonRectangle
  }
}
</script>

<style scoped>
.wrapper {
  min-height: 3em;
}
.preview-skeleton {
  position: absolute;
  top: 0.5em;
  left: 0.5em;
  right: 0.5em;
  bottom: 0.5em;
}
.frame {
  position: absolute;
  left: 50%;
  top: 50%;
}
.centered-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/preview/SampleAdPreview.vue